// Cambio de clave del usuario logueado. Cierra las sesiones de otros
// dispositivos; la actual sigue activa.

import { api } from "../api";

export function renderClave(contenedor: HTMLElement): void {
  contenedor.innerHTML = `
    <div class="mx-auto max-w-sm">
      <div class="mb-4">
        <h1 class="titulo-pagina">Cambiar clave</h1>
        <p class="subtitulo">La nueva clave debe tener al menos 8 caracteres.</p>
      </div>
      <form id="f" class="tarjeta space-y-3">
        <label class="block"><span class="etiqueta">Clave actual</span>
          <input id="actual" type="password" class="campo" autocomplete="current-password" /></label>
        <label class="block"><span class="etiqueta">Clave nueva</span>
          <input id="nueva" type="password" class="campo" autocomplete="new-password" /></label>
        <label class="block"><span class="etiqueta">Repetir clave nueva</span>
          <input id="repetir" type="password" class="campo" autocomplete="new-password" /></label>
        <p id="msg" class="text-sm"></p>
        <button class="btn-primario w-full">Cambiar clave</button>
      </form>
    </div>`;

  const msg = contenedor.querySelector("#msg") as HTMLElement;
  const form = contenedor.querySelector("#f") as HTMLFormElement;

  form.addEventListener("submit", async (ev) => {
    ev.preventDefault();
    msg.textContent = "";
    msg.className = "text-sm text-red-600";
    const val = (id: string) => (contenedor.querySelector("#" + id) as HTMLInputElement).value;
    if (val("nueva").length < 8) {
      msg.textContent = "La clave nueva debe tener al menos 8 caracteres.";
      return;
    }
    if (val("nueva") !== val("repetir")) {
      msg.textContent = "Las claves nuevas no coinciden.";
      return;
    }
    try {
      await api.post("/api/clave", { clave_actual: val("actual"), clave_nueva: val("nueva") });
      form.reset();
      msg.className = "text-sm text-green-700";
      msg.textContent = "✓ Clave cambiada. Las sesiones en otros dispositivos se cerraron.";
    } catch (e) {
      msg.textContent = e instanceof Error ? e.message : "Error";
    }
  });
}
